jQuery.feature_import("js-inventory-export",
  () => require("./inventory-export.js"),
  mod => mod.feature_js_inventory
);